import { render, staticRenderFns } from "./content-header.vue?vue&type=template&id=1b59c379&scoped=true"
import script from "./content-header.vue?vue&type=script&lang=js"
export * from "./content-header.vue?vue&type=script&lang=js"
import style0 from "./content-header.vue?vue&type=style&index=0&id=1b59c379&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59c379",
  null
  
)

export default component.exports